module.exports = __webpack_public_path__ + "static/notice-position-do-235726c20ebc050d264a8a75c9bd734c.png";